// Filtro por estado y ordenación de las tablas de partidos. Lógica pura.

export const COLUMNAS = [
  { clave: 'jornada', titulo: 'Jornada' },
  { clave: 'fecha', titulo: 'Fecha' },
  { clave: 'local', titulo: 'Local' },
  { clave: 'visitante', titulo: 'Visitante' },
  { clave: 'fase', titulo: 'Fase' },
  { clave: 'estado', titulo: 'Estado' },
  { clave: 'fechaJugado', titulo: 'Fecha jugado' },
];

export const ORDEN_INICIAL = { columna: 'jornada', direccion: 'asc' };

// Valor por el que se ordena cada columna. null = "sin valor": va siempre al
// final, ascendente o descendente.
const valorDe = (partido, columna, estados) => {
  switch (columna) {
    case 'jornada': return partido.jornada;
    case 'fecha': return partido.fecha;
    case 'local': return partido.local_nombre;
    case 'visitante': return partido.visitante_nombre;
    case 'fase': return partido.tipo === 'VUELTA' ? 1 : 0;
    // Por el orden del catálogo (el mismo del filtro), no alfabético.
    case 'estado': return estados[partido.estado_codigo]?.orden ?? Number.MAX_SAFE_INTEGER;
    case 'fechaJugado': return partido.fecha_jugado;
    default: return null;
  }
};

const comparar = (a, b) =>
  typeof a === 'string' ? a.localeCompare(b, 'es', { sensitivity: 'base' }) : a - b;

export const ordenarPartidos = (partidos, { columna, direccion }, estados = {}) => {
  const signo = direccion === 'desc' ? -1 : 1;
  return [...partidos].sort((p, q) => {
    const a = valorDe(p, columna, estados);
    const b = valorDe(q, columna, estados);
    if (a == null && b != null) return 1;
    if (b == null && a != null) return -1;
    const principal = a == null ? 0 : signo * comparar(a, b);
    // Desempate estable: jornada creciente, luego ida antes que vuelta.
    return principal || p.jornada - q.jornada || (p.tipo === 'VUELTA') - (q.tipo === 'VUELTA');
  });
};

// Pulsar la columna ya activa invierte el sentido; otra columna empieza ascendente.
export const siguienteOrden = (actual, columna) =>
  actual.columna === columna
    ? { columna, direccion: actual.direccion === 'asc' ? 'desc' : 'asc' }
    : { columna, direccion: 'asc' };

export const filtrarPorEstado = (partidos, codigo) =>
  codigo ? partidos.filter((p) => p.estado_codigo === codigo) : partidos;

// Opciones del filtro: solo estados con algún partido, en el orden del
// catálogo. `total` es el número de partidos (todas las modalidades) para
// poder mostrar "filtrados / totales".
export const contarPorEstado = (partidos, estados) => {
  const cuenta = {};
  partidos.forEach((p) => { cuenta[p.estado_codigo] = (cuenta[p.estado_codigo] ?? 0) + 1; });
  return Object.entries(cuenta)
    .map(([codigo, n]) => ({ codigo, n, etiqueta: estados[codigo]?.etiqueta ?? codigo, orden: estados[codigo]?.orden ?? Number.MAX_SAFE_INTEGER }))
    .sort((a, b) => a.orden - b.orden);
};
